<template>
	<div class="container-wrapper">
<go-back v-if="!$store.state.isMobile" v-model="form" url="/admin/organization-list" label="Back" :backToList="true"></go-back>
<b-container class="add-new-primary-organization-container" v-if="form != null">
<b-form @submit="onSubmit" @reset="onReset">
<b-row>
	<b-col cols="12" md="6">

	<h1 class="page-title inner-page">New Organization</h1>
	<b-row>
		<b-col class="pt-2">
			<b-form-group label="Organization Name"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.name.value"
				:state="form.name.status"
				@input="form.name.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
			<b-form-group label="Domain For User Accounts"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
				<ul>
			<li>The user domain will be used as part of the login for users of your organization.</li>
			<li>The login name of each user will be in the form of <strong><em>user</em></strong><strong>@domain</strong>.</li>
			<li>Any groups created within your organization will also have the same user domain.</li>
			<li>The domain does not need to be the same as your email address domain.</li>
			<li>Include the '@' symbol as part of your domain</li>
			</ul>
			<b-input-group prepend="user">
				<b-form-input placeholder="@mycompany" v-model="form.domain.value"></b-form-input>
			</b-input-group>
			</b-form-group>
		</b-col>
	</b-row>

	<b-form-group label="Type of Organization"
		:state="form.organizationTypeId.status"
		:invalid-feedback="form.organizationTypeId.invalidMessage"
		v-if="canSetApproval()"
	>
	<b-input-group>
		<b-form-select v-model="form.organizationTypeId.value"
			@input="form.organizationTypeId.resetStatus()"
			:state="form.organizationTypeId.status"
			:options="Organization.getOrganizationTypeId"
			value-field="value"
			text-field="text"
			inline
		></b-form-select>
	</b-input-group>
	</b-form-group>

	<b-row v-if="canSetActive()">
	<b-col>
		<b-form-group  label="Is Organization Active?"
			:state="form.isActive.status"
			:invalid-feedback="form.isActive.invalidMessage"
			id="fg-is-active"
			class="fg-is-active"
		>
			<b-form-radio-group
				id="rg-is-active"
				v-model="form.isActive.value"
				:options="Organization.getIsActiveOptions"
				@change="form.isActive.resetStatus()"
				:state="form.isActive.status"
			>
			</b-form-radio-group>
		</b-form-group>
	</b-col>
	</b-row>

	<b-row v-if="canEditComments()">
		<b-col>
			<b-form-group label="Comments"
				:state="form.comments.status"
				:invalid-feedback="form.comments.invalidMessage"
			>
			<wysiwyg v-model="form.comments.value"></wysiwyg>
			</b-form-group>
		</b-col>
	</b-row>

	</b-col>
	<b-col cols="12" md="6" >
	<h1>User Information</h1>

	<b-row>
	<b-col  class="pt-2">

	<b-form-group label="Username"
				:state="form.username.status"
				:invalid-feedback="form.username.invalidMessage"
			>
			<p>The login name will be in the form of <strong>user@domain</strong></p>
			<p>If left empty, an email will be sent to the user's email address to create account.</p>
			<b-input-group>
				<b-input-group :append="form.domain.value">
					<b-form-input placeholder="user" v-model="usernamePrefix.value"
						:state="usernamePrefix.status"
						@input="usernamePrefix.resetStatus()"
					></b-form-input>
				</b-input-group>
				</b-input-group>
			</b-form-group>
			<p v-if="form.username.value">The login name will be <strong>{{form.username.value}}</strong></p>

	<b-form-group label="First Name"
		:state="form.firstName.status"
		:invalid-feedback="form.firstName.invalidMessage"
	>
	<b-form-input placeholder="First Name" v-model="form.firstName.value"
		:state="form.firstName.status"
		@input="form.firstName.resetStatus()"
	></b-form-input>
	</b-form-group>


	<b-form-group label="Last Name"
		:state="form.lastName.status"
		:invalid-feedback="form.lastName.invalidMessage"
	>
	<b-form-input placeholder="Last Name" v-model="form.lastName.value"
		:state="form.lastName.status"
		@input="form.lastName.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Title"
		:state="form.title.status"
		:invalid-feedback="form.title.invalidMessage"
	>
	<b-form-input placeholder="Title" v-model="form.title.value"
		:state="form.title.status"
		@input="form.title.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Email Address"
		:state="form.email.status"
		:invalid-feedback="form.email.invalidMessage"
	>
	<b-form-input type="email" placeholder="Email Address" v-model="form.email.value"
		:state="form.email.status"
		@input="form.email.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Primary Phone"
		:state="form.phone.status"
		:invalid-feedback="form.phone.invalidMessage"
	>
	<b-input id="addPrimaryOrgUserPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="form.phone.value" placeholder="1-###-###-####"/>
	</b-form-group>


	<b-form-group label="Alternate Phone"
		:state="form.altPhone.status"
		:invalid-feedback="form.altPhone.invalidMessage"
	>
	<b-input id="addPrimaryOrgUserAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="form.altPhone.value" placeholder="1-###-###-####"/>
	</b-form-group>

	</b-col>
	</b-row>

	</b-col>
</b-row>

<b-row>
	<b-col class="create__organization">
		<b-button variant="primary" type="button" @click="onSubmit">Create Organization and User</b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
</b-container>
<Spinner v-else />
</div>
</template>

<script>
import NewPrimaryOrganization from '../../../models/NewPrimaryOrganization';
import BootstrapField from '../../../utility/BootstrapField';
import ErrorHandler from '../../../utility/ErrorHandler';
import Organization from '../../../models/Organization';

import GoBack from '../../../components/GoBack.vue';

import Spinner from "./../../../components/Spinner.vue";

import Vue from 'vue';

export default {
	name: 'add-primary',
	docTitle: "New Organization - Lane Closures",

	components: {
		GoBack,
		Spinner,
	},

    data() {
        return {
			Organization,
			form: null,
			usernamePrefix: new BootstrapField({ value: null }),
			passwordStrength: 0,
			saveState: null,
			submissionStatus: null,
			modalRequiredFieldList: null,
			showRequiredFieldModal: false,
			isButtonDisabled: false,
			onSubmitPromiseDeferred: {
				resolve:null,
				reject:null
			},
			showUnsavedChangesModal: false,
        }
	},
	mounted() {
		this.LoadData();
		this.$nextTick(() => {
		});
    },
	computed: {

	},
	watch: {
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'form.domain.value':function() {
			this.calculateUserName();
		},
	},
	methods: {
		 onPhoneFocus:function() {
    		if (this.form.phone.value == null || this.form.phone.value == "") {
    			setTimeout(function(){
    			      document.getElementById('addPrimaryOrgUserPhone').value = "1-";
    			      document.getElementById('addPrimaryOrgUserPhone').selectionStart = document.getElementById('addPrimaryOrgUserPhone').value.length;
    			      document.getElementById('addPrimaryOrgUserPhone').selectionEnd = document.getElementById('addPrimaryOrgUserPhone').value.length;
    			    },1);  // call the function after 50ms
    		}
    	},
    	onPhoneBlur:function() {
    		if (this.form.phone.value == "1-" || document.getElementById('addPrimaryOrgUserPhone').value == "1-") {
    			this.form.phone.value = null;
    			setTimeout(function(){
    			    document.getElementById('addPrimaryOrgUserPhone').value = null;
    			},1);  // call the function after 50ms
    		}
    	},
    	onAltPhoneFocus:function() {
    		if (this.form.altPhone.value == null || this.form.altPhone.value == "") {
    				// this.form.altPhone.value = "1-";
    			setTimeout(function(){
    			      document.getElementById('addPrimaryOrgUserAltPhone').value = "1-";
    			      document.getElementById('addPrimaryOrgUserAltPhone').selectionStart = document.getElementById('addPrimaryOrgUserAltPhone').value.length;
    			      document.getElementById('addPrimaryOrgUserAltPhone').selectionEnd = document.getElementById('addPrimaryOrgUserAltPhone').value.length;
    			    },1);  // call the function after 50ms

    		}
    	},
    	onAltPhoneBlur:function() {
    		if (this.form.altPhone.value == "1-" || document.getElementById('addPrimaryOrgUserAltPhone').value == "1-") {
    			this.form.altPhone.value = null;
    			setTimeout(function(){
    			    document.getElementById('addPrimaryOrgUserAltPhone').value = null;
    			},1);  // call the function after 50ms
    		}
    	},
		LoadData() {
			this.form = new NewPrimaryOrganization()
			this.form.saveChanges()
		},
		canEditComments	() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
		calculateUserName() {
			if (this.form) {
				if (this.usernamePrefix.value && this.form.domain.value) {
					this.form.username.value = this.usernamePrefix.value + this.form.domain.value;
				} else {
					this.form.username.value = null;
				}
			} else {
				this.form.username.value = null;
			}
		},
		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		},
		canSetActive() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
		canSetApproval() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			if (this.form) {
				return true;
			}
		}
		return false;
	},

		onSubmit(evt) {
			evt.preventDefault();
			if (!this.validateFields()) {
				return false;
			}
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.form);
			});
		},
		onReset() {

		},

		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		Save(t) {
			if (t instanceof NewPrimaryOrganization) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/organization/primary/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					// Handle Success
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		SaveSuccess() {
			this.form.saveChanges();
			this.$router.push("/admin/organization-list/");
		},

		validateFields() {
			let valid = this.form.validate();
			if (valid ) {
				return true;
			}
			return false;
		},

		showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		modalOnCancel() {
			this.showUnsavedChangesModal = false;
		},
	},

	beforeRouteLeave(to, from, next) {
		if (this.form.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
